import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../../../createApiConfig'
import { param } from 'jquery'

export const customerTicketsApi = createApi({
  reducerPath: 'customerTicketsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['CustomerTickets', 'TicketAttachments'],
  endpoints: builder => ({
    getCustomerTickets: builder.query({
      query: params => ({ url: `/customers/customer-tickets`, params }),
      providesTags: ['CustomerTickets']
    }),

    createCustomerTicket: builder.mutation({
      query: ({ data }) => ({
        url: `/customers/customer-tickets/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['CustomerTickets']
    }),

    getCustomerTicketById: builder.query({
      query: ({ id }) => ({
        url: `/customers/customer-tickets/${id}/`,
        method: 'GET'
      }),
      providesTags: (result, error, { id }) => [
        { type: 'CustomerTickets', id: id }
      ]
    }),

    updateCustomerTicket: builder.mutation({
      query: ({ id, data }) => ({
        url: `/customers/customer-tickets/${id}/`,
        method: 'PATCH',
        body: data
      }),
      invalidatesTags: ['CustomerTickets']
    }),

    getCustomerTicketsAttachments: builder.query({
      query: id => `/customers/ticket-attachments/${id}`,
      providesTags: ['TicketAttachments']
    }),

    createCustomerTicketAttachments: builder.mutation({
      query: ({ data }) => ({
        url: `/customers/ticket-attachments/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['TicketAttachments']
    }),

    getCustomerTicketAttachmentsById: builder.query({
      query: ({ id }) => ({
        url: `/customers/ticket-attachments/${id}/`,
        method: 'GET'
      }),
      providesTags: (result, error, { id }) => [
        { type: 'TicketAttachments', id: id }
      ]
    }),

    updateCustomerAttachmentsTicket: builder.mutation({
      query: ({ id, data }) => ({
        url: `/customers/ticket-attachments/${id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'TicketAttachments', id: id }
      ]
    }),

    getOpenTicketsCount: builder.query({
      query: () => ({ url: `/customers/tickets/open-count/` }),
    }),
  })
})

export const {
  useGetCustomerTicketsQuery,
  useLazyGetCustomerTicketsQuery,
  useCreateCustomerTicketMutation,
  useGetCustomerTicketsByIdQuery,
  useUpdateCustomerTicketMutation,
  useGetCustomerTicketsAttachmentsQuery,
  usecreateCustomerTicketAttachmentsMutation,
  useGetCustomerTicketAttachmentsByIdQuery,
  useUpdateCustomerAttachmentsTicketMutation,
  useGetOpenTicketsCountQuery
} = customerTicketsApi
